import base from './base'
export default {
  ...base,
  ref_id: {
    type: ['undefined', 'string']
  },
  ref_type: {
    type: ['undefined', 'string']
  },
  content: {
    type: ['undefined', 'string']
  },
  is_verified: {
    type: ['boolean'],
    default: false
  },
  account: {
    type: ['object'],
    default: () => {
      return {}
    }
  },
  children: {
    type: ['array'],
    default: () => []
  },
}
